import { combineReducers } from 'redux';
import StepOneSliceReducer from 'entities/mite-policy/step-1/index';
import StepTwoSliceReducer from 'entities/mite-policy/step-2/index';
import StepTreeSliceReducer from 'entities/mite-policy/step-3/index';
import FeedbackMobAppSliceReducer from 'entities/feedback-mob-app/index';
import MainPageSliceReducer from 'entities/main-page/index';
import StepOneCancerReducer from 'entities/cancer-protection/step-1/index';
import StepTwoCancerReducer from 'entities/cancer-protection/step-2/index';
import StepTreeCancerReducer from 'entities/cancer-protection/step-3/index';
import StepTwoHealthReducer from 'entities/health-ai/step-2/index';
import StepOneHealthReducer from 'entities/health-ai/step-1/index';
import StepTreeHealthReducer from 'entities/health-ai/step-3/index';

const rootReducer = combineReducers({
    stepOne: StepOneSliceReducer,
    stepTwo: StepTwoSliceReducer,
    stepTree: StepTreeSliceReducer,
    feedbackMobApp: FeedbackMobAppSliceReducer,
    mainPage: MainPageSliceReducer,
    stepOneCancer: StepOneCancerReducer,
    StepTwoCancer: StepTwoCancerReducer,
    StepTreeCancer: StepTreeCancerReducer,
    StepOneHealth: StepOneHealthReducer,
    StepTwoHealth: StepTwoHealthReducer,
    StepTreeHealth: StepTreeHealthReducer,
});

export default rootReducer;